import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authService } from '../services/authService';
import { API_URL } from '../config';
import './AuthForm.css';

export default function LoginPage() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            // 1. Authenticate with Cognito
            const result = await authService.login(username, password);

            // 2. Get the Access Token
            const accessToken = result.getAccessToken().getJwtToken();

            // 3. Save to localStorage for other components to use
            localStorage.setItem('authToken', accessToken);

            // 4. Initialize Profile in Backend (Syncs Cognito user to DynamoDB)
            await fetch(`${API_URL}/api/profile/initialize`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                }
            });

            // 5. Redirect
            navigate('/chat');

        } catch (err) {
            console.error(err);
            setError(err.message || 'Failed to login.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-container">
            <div className="auth-form">
                <h1 className="auth-title">Login</h1>
                {error && <p className="auth-error">{error}</p>}
                <form onSubmit={handleSubmit}>
                    <input
                        type="text"
                        placeholder="Username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                        className="auth-input"
                    />
                    <input
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        className="auth-input"
                    />
                    <button type="submit" className="auth-button" disabled={loading}>
                        {loading ? "Logging in..." : "Login"}
                    </button>
                </form>
                <p className="auth-link">
                    Don't have an account? <Link to="/register">Register</Link>
                </p>
                <p className="auth-link" style={{ marginTop: '8px', fontSize: '14px' }}>
                    <Link to="/forgot-password" style={{ color: '#718096' }}>Forgot your password?</Link>
                </p>
            </div>
        </div>
    );
}